import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';
import EducationContent from '../components/education-detail/EducationContent';
import EducationMeta from '../components/education-detail/EducationInfo';
import EducationMedia from '../components/education-detail/EducationMedia';
import { EDUCATION_LINKS } from '../EducationLinks';
import { getEducationDetailQueryOptions } from '../queries/getEducationDetail/getEducationDetailQueryOptions';

const EducationDetailPage = () => (
  <MainLayout header="titleHeader" title="جزئیات آموزش" fullWidth>
    <EducationDetail />
  </MainLayout>
);

function EducationDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data, error, isError, isPending } = useQuery(
    getEducationDetailQueryOptions({ id: id! }),
  );

  useEffect(() => {
    const statusCode = (error as { statusCode?: number } | null)?.statusCode;

    if (isError && statusCode === 404) {
      navigate(EDUCATION_LINKS.education, { replace: true });
    }
  }, [error, isError, navigate]);

  if (isPending || !data) {
    return <LoadingPage />;
  }

  return (
    <Box padding="24px 0px" display="flex" flexDirection="column" gap={10}>
      <EducationMedia data={data} />
      <Box width="90%" margin="auto">
        <EducationMeta data={data} />
        <EducationContent data={data} />
      </Box>
    </Box>
  );
}
export default EducationDetailPage;
